import { RadioButton, Size } from '@laerdal/life-react-components';
import React from 'react';
import { Organization } from 'types';

interface ListOrganizationsProps {
  selectedOrgId: string | undefined;
  availableOrganizations: Organization[];
  handleSelectedOrganization: (organizationId: string) => void;
}

export const ListAvailableOrganizations = ({ selectedOrgId, availableOrganizations, handleSelectedOrganization }: ListOrganizationsProps) => {
  return (
    <>
      {availableOrganizations
        .sort((o1, o2) => o1.name.localeCompare(o2.name))
        .map((org) => (
          <RadioButton
            key={`org_${org.id}`}
            id={`org_${org.id}`}
            size={Size.Small}
            selected={selectedOrgId === org.id}
            select={() => {
              handleSelectedOrganization(org.id);
            }}
            label={org.name}
            additionalLabel={`${org.address?.city ?? ''}${org.address?.state && org.address?.city ? `, ` : ''}${org.address?.state ? org.address.state.toUpperCase() : ''}`}
          />
        ))}
    </>
  );
};
